import React, { useEffect, useRef, useState } from 'react';
import Graphic from "@arcgis/core/Graphic";
import Select from "react-select";
import { useDispatch, useSelector } from "react-redux";
import { setIsDist, setIsUlb, setIsWard } from "../../store/slice/currentStageSlice";
import * as XLSX from 'xlsx';
import MAPTaxInsights from '../../componets/MAPTaxInsights';
import { useNavigate } from "react-router-dom";
// PrimeReact Imports
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Paginator } from 'primereact/paginator';
import "primereact/resources/themes/lara-light-indigo/theme.css"; // Theme
import "primereact/resources/primereact.min.css";                 // Core CSS
import "primeicons/primeicons.css";
import { FaChevronDown, FaChevronUp } from "react-icons/fa";
import { Chart } from "react-google-charts";
import LayerControlPanel from '../../componets/LayerControlPanel';                            // Icons
const layersData = [
    "Administrative Boundaries",
    "Agriculture",
    "Climate",
    "Cooperative Societies",
    "Cultural",
    "Education",
    "Election",
    "Emergency Services",
    "Excise",
];





// === Sublayer Groups ===
const BASE_SERVICE_URL = "https://urbangis.mp.gov.in/server/rest/services/temp_n/urbangis_temp/MapServer";

const ADMIN_BOUNDARIES_SUBLAYERS = [
    { id: 1, title: "MP State", visible: false },
    { id: 2, title: "MP Division", visible: false },
    { id: 3, title: "MP District", visible: true },
    { id: 94, title: "MP ULB", visible: true },
    { id: 95, title: "MP Ward", visible: false },
    { id: 5, title: "Municipal Area", visible: false },
    { id: 7, title: "Municipal Ward", visible: false },
];

const PROPERTY_SUBLAYERS = [
    { id: 14, title: "Property", visible: false },
    { id: 15, title: "Building Footprint", visible: false },
    { id: 16, title: "Builtup Area", visible: false },
    { id: 17, title: "Slum Area", visible: false },
    { id: 39, title: "Industrial Area", visible: false },
];

const GREEN_SPACE_SUBLAYERS = [
    { id: 30, title: "Agricultural Area", visible: false },
    { id: 32, title: "Forest", visible: false },
    { id: 33, title: "Vacant Lands", visible: false },
    { id: 34, title: "Waste Lands", visible: false },
    { id: 36, title: "Open Land", visible: false },
    { id: 38, title: "Playground", visible: false },
    { id: 41, title: "Plantation", visible: false },
    { id: 42, title: "Orchyard", visible: false },
    { id: 43, title: "Park", visible: false },
];

const TRANSPORTATION_SUBLAYERS = [
    { id: 45, title: "Roads", visible: false },
    { id: 56, title: "Railway", visible: false },
    { id: 59, title: "Railway Station", visible: false },
    { id: 61, title: "Aircraft Road", visible: false },
    { id: 62, title: "Airport", visible: false },
    { id: 63, title: "Helipad", visible: false },
    { id: 64, title: "Busstand", visible: false },
];

const WATERBODIES_SUBLAYERS = [
    { id: 69, title: "Rivers", visible: false },
    { id: 70, title: "Drainage or Nala", visible: false },
    { id: 75, title: "Lake/Pond/Reservoir", visible: false },
];

const LANDMARKS_SUBLAYERS = [
    { id: 79, title: "Important Landmarks", visible: false },
];

const MASTER_PLAN_URL = "https://urbangis.mp.gov.in/server/rest/services/temp_n/master_plan/MapServer";

const MASTER_PLAN_SUBLAYERS = [
    { id: 1, title: "Planning Area", visible: false },
    { id: 2, title: "Master Plan Village Boundary", visible: false },
    { id: 3, title: "Master Plan", visible: false },
];

const SAMPDA_GUIDELINE_URL = "https://urbangis.mp.gov.in/server/rest/services/temp_n/sampda_guideline/MapServer";

const SAMPDA_GUIDELINE_SUBLAYERS = [
    { id: 1, title: "Sampda Guideline 2025_26", visible: false },
];

const WATER_URL = "https://urbangis.mp.gov.in/server/rest/services/temp_n/watersupply_project/MapServer";

const WATER_SUBLAYERS = [
    { id: 1, title: "WTP", visible: false },
    { id: 2, title: "Intake Well", visible: false },
    { id: 3, title: "OHT", visible: false },
    { id: 4, title: "Junction", visible: false },
    { id: 5, title: "RWPM", visible: false },
    { id: 6, title: "CWPM", visible: false },
    { id: 7, title: "Distribution Line", visible: false },
];

const SEWER_URL = "https://urbangis.mp.gov.in/server/rest/services/temp_n/sewerage_project/MapServer";

const SEWER_SUBLAYERS = [
    { id: 1, title: "STP", visible: false },
    { id: 2, title: "MPS", visible: false },
    { id: 3, title: "IPS", visible: false },
    { id: 4, title: "Manhole", visible: false },
    { id: 5, title: "Sewer Line", visible: false },
];

const ASSETS_URL1 = "https://urbangis.mp.gov.in/server/rest/services/temp_n/govt_assets_mis/MapServer";

const ASSETS_Central_SUBLAYERS = [
    { id: 2, title: "Central Govt Assets", visible: false },
    { id: 3, title: "State Govt Assets",   visible: false },
    { id: 4, title: "Municipal Govt Assets", visible: false}
];

const BaseMapURL = "https://urbangis.mp.gov.in/server/rest/services/temp_n/urbangis_basemap/FeatureServer";

const BaseMapURL_SubLayer = [
    { id: 15, title: "plotbuildingstructure", visible: true },
    { id: 45, title: "roadcenterline", visible: true },
    { id: 56, title: "railwaycenterline", visible: true },    
    { id: 75, title: "waterbodies", visible: false },
     { id: 79, title: "importantlandmarks", visible: true },
     
];

const MPLanduse = "https://urbangis.mp.gov.in/server/rest/services/temp_n/mp_lulc_change/MapServer";
const MPLanduse_sublayer = [
    { id: 6, title: "Landuse 2022", visible: false },
    { id: 8, title: "Landuse 2024", visible: false },   
];

const StormWaterURL = "https://urbangis.mp.gov.in/server/rest/services/temp_n/stormwater_project_data/MapServer";
const StormWaterURL_sublayer = [
    { id: 1, title: "Storm Water Drainage Line", visible: false },
    
];
// === Layer Groups ===

const SBM_URL1 = "https://urbangis.mp.gov.in/server/rest/services/temp_n/sbm_data/MapServer";
const SBM_SUBLAYERS = [
    { id: 1, title: "All Processing Plant", visible: false },
    { id: 11, title: "Bio Methanation", visible: false },
    { id: 12, title: "C&D Waste Processing Facility", visible: false },
    { id: 13, title: "Faecal Sludge Treatment Plant (FSTP)", visible: false },
    { id: 14, title: "Material Recovery Facility (MRF)", visible: false },
    { id: 15, title: "STP", visible: false },
    { id: 16, title: "Waste To Compost", visible: false },
    { id: 17, title: "Waste To Energy", visible: false },
    { id: 2, title: "Dump Site", visible: false },
    { id: 3, title: "Landfill", visible: false }
];
// AMRUT 2.0
const AMRUT_URL = "https://urbangis.mp.gov.in/server/rest/services/temp_n/amrut_scheme/MapServer";
const AMRUT_SUBLAYERS = [
    { id: 1, title: "Green Space Development", visible: false },
    { id: 2, title: "Waterbody Rejuvenation", visible: false },

];
const GROUPS = [
    { url: BASE_SERVICE_URL, title: "Administrative Boundaries", sublayers: ADMIN_BOUNDARIES_SUBLAYERS },
    { url: ASSETS_URL1, title: "Government Assets", sublayers: ASSETS_Central_SUBLAYERS },
    { url: BASE_SERVICE_URL, title: "Properties", sublayers: PROPERTY_SUBLAYERS },
    { url: BASE_SERVICE_URL, title: "Green Spaces", sublayers: GREEN_SPACE_SUBLAYERS },
    { url: BASE_SERVICE_URL, title: "Transportation", sublayers: TRANSPORTATION_SUBLAYERS },
    { url: BASE_SERVICE_URL, title: "Waterbodies", sublayers: WATERBODIES_SUBLAYERS },
    { url: BASE_SERVICE_URL, title: "Landmarks", sublayers: LANDMARKS_SUBLAYERS },
    { url: SBM_URL1, title: "SBM", sublayers: SBM_SUBLAYERS },
    { url: AMRUT_URL, title: "AMRUT 2.0", sublayers: AMRUT_SUBLAYERS },
    { url: MASTER_PLAN_URL, title: "Master Plan", sublayers: MASTER_PLAN_SUBLAYERS },
    { url: SAMPDA_GUIDELINE_URL, title: "Sampda Guideline", sublayers: SAMPDA_GUIDELINE_SUBLAYERS },
    { url: WATER_URL, title: "Water Supply Network", sublayers: WATER_SUBLAYERS },
    { url: SEWER_URL, title: "Sewerage Network", sublayers: SEWER_SUBLAYERS },
    { url: StormWaterURL, title: "Storm Water Network", sublayers: StormWaterURL_sublayer },
    { url: MPLanduse, title: "MP Landuse", sublayers: MPLanduse_sublayer },

];

function PropertyChangeMap2({ view }) {
    const dispatch = useDispatch();
    const { isTheme, isBufferWidth, isToolHeight } = useSelector((state) => state.currentStage);
    const authData = useSelector(state => state.authToken.authData);

    const [districts, setDistricts] = useState([]);
    const [selectedDistrict, setSelectedDistrict] = useState("");
    const [districtCode, setDistrictCode] = useState("");

    const [ulbs, setUlbs] = useState([]);
    const [selectedUlb, setSelectedUlb] = useState("");
    const [ulbCode, setUlbCode] = useState("");

    const [wards, setWards] = useState([]);
    const [selectedWard, setSelectedWard] = useState("");
    const [wardCode, setWardCode] = useState("");

    const [active, setActive] = useState("total");
    const [refactive, setRefactive] = useState("0");
    const [currentPage, setCurrentPage] = useState(1);
    const [totalRecords, setTotalRecords] = useState(0);
    const [isTableView, setIsTableView] = useState(false);

    const [filteredPropertyData, setFilteredPropertyData] = useState([]);
    const [counts, setCounts] = useState({
        totalCount: 0, paidCount: 0, unpaidCount: 0, nreCount: 0,
        negArCount: 0, yetToBeSurveyedCount: 0
    });

    const [isLoading, setIsLoading] = useState(false);
    const [isTableLoading, setIsTableLoading] = useState(false);

    // State for PrimeReact DataTable
    const [columns, setColumns] = useState([]);
    const [first, setFirst] = useState(0); // Index of the first record for Paginator
    const [rows, setRows] = useState(500); // Rows per page for Paginator

    const [activeSelect, setActiveSelect] = useState("area");
    const [expanded, setExpanded] = useState({});
    const [checked, setChecked] = useState({});
    const [search, setSearch] = useState("");
    const [layerGroups, setLayerGroups] = useState(GROUPS);
    const navigate = useNavigate();
    const toggleLayer = (groupTitle, sublayerId) => {
        const updatedGroups = layerGroups.map(group => {
            if (group.title !== groupTitle) return group;

            const updatedSublayers = group.sublayers.map(sublayer =>
                sublayer.id === sublayerId
                    ? { ...sublayer, visible: !sublayer.visible }
                    : sublayer
            );

            return { ...group, sublayers: updatedSublayers };
        });

        setLayerGroups(updatedGroups);
    };

    const stats = [
        { value: counts?.totalCount, title: "Total MPHS Properties" },
        { value: counts?.paidCount, title: "Tax Paid Properties" },
        { value: counts?.unpaidCount, title: "Tax Unpaid Properties" },
        { value: counts?.nreCount, title: "Properties not registered on ENP" },
        { value: counts?.yetToBeSurveyedCount, title: "Yet To Be Surveyed" },
        { value: counts?.negArCount, title: "Negative (-) Arrear" },
    ];

    const dataChart = [
        ["Category", "Properties"],
        // ["Total MPHS Properties", counts.totalCount],
        ["Tax Paid Properties", counts.paidCount],
        ["Tax Unpaid Properties", counts.unpaidCount],
        ["Properties not registered on ENP", counts.nreCount],
        ["Yet To Be Surveyed", counts.yetToBeSurveyedCount],
        ["Properties with Negative (-) Arrear", counts.negArCount],
    ];

    const toggleExpand = (layer) => {
        setExpanded((prev) => ({ ...prev, [layer]: !prev[layer] }));
    };

    const toggleCheck = (layer) => {
        setChecked((prev) => ({ ...prev, [layer]: !prev[layer] }));
    };

    const filteredLayers = layersData.filter((layer) =>
        layer.toLowerCase().includes(search.toLowerCase())
    );





    const handleTableView = () => setIsTableView(!isTableView);

    useEffect(() => {
        const loadDistricts = async () => {
            const url = "https://urbangis.mp.gov.in/server/rest/services/temp_n/urbangis_temp/FeatureServer/3/query?where=1=1&outFields=districtname,dist_cd&returnGeometry=false&returnDistinctValues=true&f=geojson";
            try {
                const response = await fetch(url);
                const data = await response.json();
                if (authData?.UserType === "districtuser" || authData?.UserType === "User") {
                    const userDistrict = [{ districtName: authData.DistrictName, districtCode: authData.DistrictCode }];
                    setDistricts(userDistrict); setDistrictCode(authData.DistrictCode); setSelectedDistrict(authData.DistrictName);
                    await loadUlbs(authData.DistrictCode);
                } else {
                    const formatted = data.features.map(f => ({ districtName: f.properties.districtname, districtCode: f.properties.dist_cd }));
                    setDistricts(formatted);
                }
            } catch (err) { console.error("Error loading districts:", err); }
        };
        if (authData) loadDistricts();
    }, [authData]);

    const loadUlbs = async (dist_cd) => {
        const url = `https://urbangis.mp.gov.in/server/rest/services/temp_n/urbangis_temp/FeatureServer/5/query?where=dist_cd='${dist_cd}'&returnGeometry=false&outFields=name,ulb_cd&returnDistinctValues=true&f=geojson`;
        try {
            const response = await fetch(url);
            const data = await response.json();
            if (authData?.UserType === "User") {
                const formattedUlbs = [{ ulbName: authData?.UlbName, ulbCode: authData?.Ulb_Code }];
                setUlbs(formattedUlbs); setUlbCode(authData?.Ulb_Code); setSelectedUlb(authData?.UlbName);
                await loadWards(authData?.Ulb_Code);
            } else if (data.features) {
                const formattedUlbs = data.features.map(f => ({ ulbName: f.properties.name, ulbCode: f.properties.ulb_cd }));
                setUlbs(formattedUlbs);
            }
        } catch (err) { console.error("Error loading ULBs:", err); }
    };

    const loadWards = async (ulb_cd) => {
        const url = `https://urbangis.mp.gov.in/server/rest/services/temp_n/urbangis_temp/FeatureServer/7/query?where=ulb_cd='${ulb_cd}'&returnGeometry=false&outFields=wardname,wardno&returnDistinctValues=true&f=geojson`;
        try {
            const response = await fetch(url);
            const data = await response.json();
            const formatted = data.features.map(f => ({
                wardName: f.properties.wardname, wardCode: f.properties.wardno,
                displayLabel: `${f.properties.wardno} - ${f.properties.wardname}`
            }));
            setWards(formatted);
        } catch (err) { console.error("Error loading wards:", err); }
    };

    const handleDistrictChange = async (selectedOption) => {
        if (!selectedOption) { handleRefresh(); return; }
        const district = districts.find(d => d.districtCode === selectedOption.value);
        if (district) {
            setDistrictCode(district.districtCode); setSelectedDistrict(district.districtName);
            setUlbCode(""); setSelectedUlb(""); setWardCode(""); setSelectedWard("");
            await loadUlbs(district.districtCode);
            fetchAndZoomPropertyChanges({ dist_cd: district.districtCode });
        }
    };

    const handleUlbChange = async (selectedOption) => {
        if (!selectedOption) {
            setUlbCode(""); setSelectedUlb(""); setWardCode(""); setSelectedWard("");
            fetchAndZoomPropertyChanges({ dist_cd: districtCode });
            return;
        }
        const ulb = ulbs.find(u => u.ulbCode === selectedOption.value);
        if (ulb) {
            setUlbCode(ulb.ulbCode); setSelectedUlb(ulb.ulbName);
            setWardCode(""); setSelectedWard("");
            await loadWards(ulb.ulbCode);
            fetchAndZoomPropertyChanges({ dist_cd: districtCode, ulb_cd: ulb.ulbCode });
        }
    };

    const handleWardChange = async (selectedOption) => {
        if (!selectedOption) {
            setWardCode(""); setSelectedWard("");
            fetchAndZoomPropertyChanges({ dist_cd: districtCode, ulb_cd: ulbCode });
            return;
        }
        const ward = wards.find(w => w.wardCode === selectedOption.value);
        if (ward) {
            setWardCode(ward.wardCode); setSelectedWard(ward.wardName);
            fetchAndZoomPropertyChanges({ dist_cd: districtCode, ulb_cd: ulbCode, wardno: ward.wardCode });
        }
    };

    const fetchCountByRemarks = async ({ dist_cd, ulb_cd, wardno, paymentstatus, arrears }) => {
        const baseUrl = "https://urbangis.mp.gov.in/server/rest/services/temp_n/vw_property_taxinfo/MapServer/1/query";
        const whereParts = [
            dist_cd && `dist_cd='${dist_cd}'`,
            ulb_cd && `ulb_cd='${ulb_cd}'`,
            wardno && `wardno='${wardno}'`,
            paymentstatus && `paymentstatus='${paymentstatus}'`,
            arrears === "Negative Arrear" && `arrears < 0`
        ].filter(Boolean);
        const where = whereParts.length > 0 ? whereParts.join(" AND ") : "1=1";
        const params = new URLSearchParams({ where, outStatistics: JSON.stringify([{ statisticType: "count", onStatisticField: "objectid", outStatisticFieldName: "total_count" }]), f: "json" });
        try {
            const response = await fetch(`${baseUrl}?${params.toString()}`);
            const json = await response.json();
            return json.features?.[0]?.attributes?.total_count || 0;
        } catch (err) { console.error(`Error fetching count:`, err); return 0; }
    };

    const fetchCountByRemarksYetSurveyed = async ({ dist_cd, ulb_cd, wardno, remarks }) => {
        const baseUrl = "https://urbangis.mp.gov.in/server/rest/services/temp_n/property_change_detection/MapServer/14/query";
        const whereParts = [
            dist_cd && `dist_cd='${dist_cd}'`,
            ulb_cd && `ulb_cd='${ulb_cd}'`,
            wardno && `wardno='${wardno}'`,
            remarks && `remarks='${remarks}'`
        ].filter(Boolean);
        const where = whereParts.length > 0 ? whereParts.join(" AND ") : "1=1";
        const params = new URLSearchParams({ where, outStatistics: JSON.stringify([{ statisticType: "count", onStatisticField: "objectid", outStatisticFieldName: "total_count" }]), f: "json" });
        try {
            const response = await fetch(`${baseUrl}?${params.toString()}`);
            const json = await response.json();
            return json.features?.[0]?.attributes?.total_count || 0;
        } catch (err) { console.error(`Error fetching 'yet surveyed' count:`, err); return 0; }
    };

    useEffect(() => {
        const initLoad = async () => {
            setIsLoading(true);
            const filters = (authData?.UserType === "districtuser" || authData?.UserType === "User")
                ? { dist_cd: authData.DistrictCode, ulb_cd: authData.Ulb_Code } : {};
            await fetchAllCounts(filters);
            await fetchPropertyData({ ...filters, page: 1, filterType: 'total' });
            setIsLoading(false);
        };
        if (authData) initLoad();
    }, [authData]);

    const fetchAllCounts = async ({ dist_cd, ulb_cd, wardno }) => {
        try {
            const [paidCount, unpaidCount, nreCount, negArCount, totalTaxCount, yetToBeSurveyedCount] = await Promise.all([
                fetchCountByRemarks({ dist_cd, ulb_cd, wardno, paymentstatus: "Paid" }),
                fetchCountByRemarks({ dist_cd, ulb_cd, wardno, paymentstatus: "Unpaid" }),
                fetchCountByRemarks({ dist_cd, ulb_cd, wardno, paymentstatus: "Not Registered" }),
                fetchCountByRemarks({ dist_cd, ulb_cd, wardno, arrears: "Negative Arrear" }),
                fetchCountByRemarks({ dist_cd, ulb_cd, wardno }),
                fetchCountByRemarksYetSurveyed({ dist_cd, ulb_cd, wardno, remarks: "New" }),
            ]);
            setCounts({ paidCount, unpaidCount, nreCount, negArCount, totalCount: totalTaxCount + yetToBeSurveyedCount, yetToBeSurveyedCount });
        } catch (error) { console.error("Error fetching all counts:", error); }
    };

    const generateTableHeaders = (data) => {
        if (!data || data.length === 0) return [];
        const excludedKeys = ["objectid", "dist_cd", "districtname", "districtcode", "div_cd", "divisioncode", "Uaddgislab_sde_property_change_area", "ulb_cd", "ulbcode", "singlepage_id", "slumornonslum", "st_length(shape)", "st_area(shape)"];
        const excludedKeysLower = excludedKeys.map(key => key.toLowerCase());
        const keys = Object.keys(data[0]).filter(key => !excludedKeysLower.includes(key.toLowerCase()));
        return keys.map(key => ({
            field: key,
            header: key.replace(/([A-Z])/g, " $1").replace(/^./, str => str.toUpperCase()).replace(/_/g, " "),
        }));
    };

    const fetchPropertyData = async ({ dist_cd, ulb_cd, wardno, filterType = active, page = 1 }) => {
        setIsTableLoading(true);
        const baseUrl = "https://urbangis.mp.gov.in/server/rest/services/temp_n/vw_property_taxinfo/MapServer/1/query";
        const whereParts = [
            dist_cd && `dist_cd='${dist_cd}'`, ulb_cd && `ulb_cd='${ulb_cd}'`,
            wardno && `wardno='${wardno}'`
        ].filter(Boolean);
        if (["Paid", "Unpaid", "Not Registered"].includes(filterType)) whereParts.push(`paymentstatus='${filterType}'`);
        else if (filterType === "Negative Arrear") whereParts.push(`arrears<0`);

        const pageSize = rows;
        const offset = pageSize * (page - 1);
        const where = whereParts.length > 0 ? whereParts.join(" AND ") : "1=1";
        const url = `${baseUrl}?where=${encodeURIComponent(where)}&outFields=*&returnGeometry=false&f=json&resultOffset=${offset}&resultRecordCount=${pageSize}`;

        try {
            const response = await fetch(url);
            const json = await response.json();
            const properties = json.features.map(f => f.attributes);

            if (properties.length > 0) setColumns(generateTableHeaders(properties)); else setColumns([]);

            setFilteredPropertyData(properties);
            setCurrentPage(page);
            setFirst(offset);

            // *** FIX: Correctly get total records for the current filter ***
            const totalCountResponse = await fetchCountByRemarks({
                dist_cd, ulb_cd, wardno,
                paymentstatus: ["Paid", "Unpaid", "Not Registered"].includes(filterType) ? filterType : null,
                arrears: filterType === "Negative Arrear" ? "Negative Arrear" : null
            });
            setTotalRecords(totalCountResponse || 0);

        } catch (err) { console.error("Error fetching property data:", err); }
        finally { setIsTableLoading(false); }
    };

    const fetchPropertyDataYetSurveyed = async ({ dist_cd, ulb_cd, wardno, page = 1 }) => {
        setIsTableLoading(true);
        const baseUrl = "https://urbangis.mp.gov.in/server/rest/services/temp_n/property_change_detection/MapServer/14/query";
        const whereParts = [
            dist_cd && `dist_cd='${dist_cd}'`, ulb_cd && `ulb_cd='${ulb_cd}'`,
            wardno && `wardno='${wardno}'`, `remarks='New'`
        ].filter(Boolean);

        const where = whereParts.join(" AND ");
        const pageSize = rows;
        const offset = pageSize * (page - 1);
        const url = `${baseUrl}?where=${encodeURIComponent(where)}&outFields=*&returnGeometry=false&f=json&resultOffset=${offset}&resultRecordCount=${pageSize}`;

        try {
            const response = await fetch(url);
            const json = await response.json();
            const properties = json.features.map(f => f.attributes);
            if (properties.length > 0) setColumns(generateTableHeaders(properties)); else setColumns([]);
            setFilteredPropertyData(properties);
            setCurrentPage(page);
            setFirst(offset);
            // *** FIX: Correctly get total records for this specific query ***
            const totalCountResponse = await fetchCountByRemarksYetSurveyed({ dist_cd, ulb_cd, wardno, remarks: "New" });
            setTotalRecords(totalCountResponse || 0);
        } catch (err) { console.error("Error fetching 'Yet to be Surveyed' data:", err); }
        finally { setIsTableLoading(false); }
    };

    const onPageChangePrimeReact = (event) => {
        const newPage = Math.floor(event.first / event.rows) + 1;
        // No need to set state here, the fetch function will do it
        const fetchFunction = active === 'New' ? fetchPropertyDataYetSurveyed : fetchPropertyData;
        fetchFunction({ dist_cd: districtCode, ulb_cd: ulbCode, wardno: wardCode, page: newPage });
    };

    const onRowsChangePrimeReact = (newRows) => {
        setRows(newRows); // Just update rows, the effect on `initLoad` will re-fetch.
    };

    useEffect(() => {
        // This effect re-fetches data when the number of rows per page changes
        if (authData) { // Ensure it doesn't run on initial mount before authData is ready
            const fetchFunction = active === 'New' ? fetchPropertyDataYetSurveyed : fetchPropertyData;
            fetchFunction({ dist_cd: districtCode, ulb_cd: ulbCode, wardno: wardCode, page: 1 });
        }
    }, [rows]);

    const filterProperties = (filterType) => {
        setActive(filterType); setFirst(0); setCurrentPage(1);
        fetchPropertyData({ dist_cd: districtCode, ulb_cd: ulbCode, wardno: wardCode, filterType, page: 1 });
    };

    const filterPropertiesYet = () => {
        setActive("New"); setFirst(0); setCurrentPage(1);
        fetchPropertyDataYetSurveyed({ dist_cd: districtCode, ulb_cd: ulbCode, wardno: wardCode, page: 1 });
    };

    const handleGetData = (item) => {
        if (item.title === "Total MPHS Properties") filterProperties("total");
        else if (item.title === "Tax Paid Properties") filterProperties("Paid");
        else if (item.title === "Tax Unpaid Properties") filterProperties("Unpaid");
        else if (item.title === "Properties not registered on ENP") filterProperties("Not Registered");
        else if (item.title === "Properties with Negative (-) Arrear") filterProperties("Negative Arrear");
        else if (item.title === "Yet To Be Surveyed") filterPropertiesYet();
    };


    const downloadExcel = () => {
        if (filteredPropertyData.length === 0) {
            alert("No data available to download");
            return;
        }

        // Generate headers
        const headers = generateTableHeaders(filteredPropertyData);

        // Prepare data for Excel
        const excelData = filteredPropertyData.map(row => {
            const obj = {};
            headers.forEach(header => {
                obj[header.header] = row[header.field] !== undefined ? row[header.field] : "-";
            });
            return obj;
        });

        // Create worksheet
        const ws = XLSX.utils.json_to_sheet(excelData);

        // Create workbook
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, "Property Tax Data");

        // Generate Excel file
        const fileName = `Property_Tax_${selectedDistrict || 'All'}_${selectedUlb || 'All'}_${selectedWard || 'All'}_${new Date().toISOString().split('T')[0]}.xlsx`;

        // Download the file
        XLSX.writeFile(wb, fileName);
    };

    const fetchAndZoomPropertyChanges = async ({ dist_cd, ulb_cd, wardno }) => {
        setIsLoading(true);
        try {
            // Always fetch counts
            await fetchAllCounts({ dist_cd, ulb_cd, wardno });

            // Conditionally fetch property data
            if (active === "New") {
                await fetchPropertyDataYetSurveyed({ dist_cd, ulb_cd, wardno });
            } else {
                await fetchPropertyData({ dist_cd, ulb_cd, wardno });
            }
        } catch (error) {
            console.error("Error in fetchAndZoomPropertyChanges:", error);
        } finally {
            setIsLoading(false);
        }
    };

    const handleRefresh = async () => {
        setUlbs([]);
        setSelectedDistrict("");
        setDistrictCode("");
        setUlbCode('');
        setSelectedUlb('');
        setWardCode('');
        setWards([]);
        setWardCode("");
        setSelectedWard("");
        setRefactive("1")
        dispatch(setIsDist(""));
        dispatch(setIsUlb(""));
        dispatch(setIsWard(""));

        setActive("total")

        await fetchAllCounts({});
        await fetchPropertyData({});

        if (view) {
            try {
                view.graphics.removeAll();
                view.goTo({
                    target: [78.746567, 23.83403],
                    zoom: 7
                }).catch(error => {
                    console.error("Error during goTo:", error);
                });
            } catch (error) {
                console.error("Error during refresh:", error);
            }
        } else {
            console.warn("View is not available");
        }
    };

    const formatNumberWithCommas = (value) => {
        if (value === null || value === undefined || value === '') return '';
        if (typeof value === 'string') {
            if (value.includes('/')) {
                const parts = value.split('/');
                if (parts.length === 2) {
                    const numerator = formatNumberWithCommas(parts[0]);
                    const denominator = formatNumberWithCommas(parts[1]);
                    return `${numerator}/${denominator}`;
                }
            }
            const numericMatch = value.match(/([-\d,.]+)(.*)/);
            if (numericMatch) {
                const numericPart = numericMatch[1].replace(/,/g, '');
                const unitPart = numericMatch[2];
                if (!isNaN(numericPart)) {
                    const num = Number(numericPart);
                    const formattedNumber = num.toLocaleString('en-IN');
                    return `${formattedNumber}${unitPart}`;
                }
            }
            return value;
        }
        if (typeof value === 'number') {
            return value.toLocaleString('en-IN');
        }
        return value;
    };

    const chartOptions = {
        title: "Property Statistics",
        backgroundColor: "transparent",
        pieHole: 0.4, // Creates a Donut Chart. Does not do anything when is3D is enabled
        is3D: true, // 
        legend: {
            position: "right",
            textStyle: { color: isTheme === "dark" ? "white" : "black" },
        },
        titleTextStyle: {
            color: isTheme === "dark" ? "white" : "black",
            fontSize: 16,
        },
        // colors: ["#4facfe", "#43e97b", "#fa709a", "yellow", "red", 'pink'], 
        colors: ["#55ff00", "#ff0000", "#ffaa00", "#FF9797", "#ddb8c2"],
        sliceVisibilityThreshold: 0, // ✅ ensures small values are shown
    };

    const customStyles = {
        control: (provided, state) => ({
            ...provided,
            boxShadow: state.isFocused && !state.hasValue ? "0 0 0 1px #ccc" : "none",
            borderColor: state.isFocused && !state.hasValue ? "#ccc" : "#ccc",
            "&:hover": {
                borderColor: "#ccc",
            },
            fontSize: "12px",
        }),
        option: (provided, state) => ({
            ...provided,
            backgroundColor: state.isSelected
                ? "#d1ede9"
                : state.isFocused
                    ? "#d1ede9"
                    : "#FFFFFF",
            color: "#000",
            fontSize: "12px",
            padding: "10px",
        }),
        singleValue: (provided) => ({
            ...provided,
            color: "#000",
            fontSize: "12px",
        }),
        placeholder: (base) => ({
            ...base,
            color: "#000",
            fontSize: "12px",
        }),
        input: (provided) => ({
            ...provided,
            color: "#000",
            fontSize: "12px",
        }),
    };

    return (
        <div style={{ border: "none", height: isToolHeight ? 'calc(100vh - 109px)' : 'calc(100vh - 205px)' }} className='px-2'>
            {!isTableView && (
                <div>
                    <div className='row'>
                        <div className={isBufferWidth ? 'col-md-12 p-0' : 'col-md-9 p-0'}>
                            {/* <IdentifyMap /> */}
                            <MAPTaxInsights
                                selectedDistrict={selectedDistrict}
                                selectedUlb={selectedUlb}
                                selectedWard={selectedWard}
                                districtCode={districtCode}
                                ulbCode={ulbCode}
                                wardCode={wardCode}
                                activeTabinfo={active}
                                activeTabRef={refactive}
                                dist_cd={districtCode} ulb_cd={ulbCode} wardno={wardCode}
                                groups={layerGroups}
                            />
                        </div>
                        {!isBufferWidth && (
                            <div className='col-md-3 p-0'>
                                <div className='px-2'>
                                    <div className='tooltitlediv linear-gradian-bg d-flex justify-content-between align-items-center px-3'>
                                        <h6 className='sidebarbuttontitle m-0 text-white'>Tax Paid / Unpaid</h6>
                                        {/* <button className='btn text-white no-hover'
                                            onClick={() => navigate("/link-dashboard")}
                                        >Back</button> */}
                                    </div>


                                    <div className="tabs-container d-flex justify-content-between mt-2 mb-2">
                                        <button className={`tab-btn ${activeSelect === "area" ? "active" : ""}`} onClick={() => setActiveSelect("area")}>Select Area</button>
                                        <button className={`tab-btn ${activeSelect === "layer" ? "active" : ""}`} onClick={() => setActiveSelect("layer")} >Layer</button>
                                    </div>

                                    <div className={isToolHeight ? 'scroll-layerdiv' : 'scroll-layerdivheight '}>
                                        {activeSelect == "layer" ? <>
                                            <LayerControlPanel groups={layerGroups} toggleLayer={toggleLayer} />
                                        </> : <>
                                            <div className="mt-2">
                                                <label className="lebel-card-text">Select District</label>
                                                <Select
                                                    options={districts.map((district) => ({
                                                        value: district.districtCode,
                                                        label: district.districtName,
                                                    })).sort((a, b) => a.label.localeCompare(b.label))}
                                                    value={districtCode ? { value: districtCode, label: selectedDistrict } : null}
                                                    // onChange={handleDistrictChange}
                                                    onChange={(selectedOption) => {
                                                        if (!selectedOption) {
                                                            handleRefresh();
                                                        } else {
                                                            handleDistrictChange(selectedOption)
                                                        }
                                                    }
                                                    }
                                                    placeholder="Select District"
                                                    isClearable={true}
                                                    // className="mt-3"
                                                    styles={customStyles}
                                                    isDisabled={authData?.UserType === "districtuser" || authData?.UserType === "User"}
                                                />
                                            </div>
                                            <div className="mt-2">
                                                <label className="lebel-card-text">Select ULB</label>
                                                <Select
                                                    options={ulbs.map((ulb) => ({
                                                        value: ulb.ulbCode,
                                                        label: ulb.ulbName,
                                                    })).sort((a, b) => a.label.localeCompare(b.label))}
                                                    value={ulbCode ? { value: ulbCode, label: selectedUlb } : null}
                                                    onChange={handleUlbChange}
                                                    placeholder="Select ULB"
                                                    isClearable={true}
                                                    isDisabled={authData?.UserType === "districtuser" || authData?.UserType === "User" || !districtCode}
                                                    // className="mt-3"
                                                    styles={customStyles}
                                                />
                                            </div>
                                            <div className="mt-2">
                                                <label className="lebel-card-text">Select Ward</label>
                                                <Select
                                                    options={wards.map((ward) => ({
                                                        value: ward.wardCode,
                                                        label: ward.displayLabel,
                                                    })).sort((a, b) => a.label.localeCompare(b.label))}
                                                    value={wardCode ? { value: wardCode, label: selectedWard } : null}
                                                    onChange={handleWardChange}
                                                    placeholder="Select ward"
                                                    styles={customStyles}
                                                    isClearable={true}
                                                    isDisabled={!ulbCode}
                                                // className="mt-3"
                                                />
                                            </div>
                                            <Chart
                                                chartType="PieChart"
                                                width="100%"
                                                height="300px"
                                                data={dataChart}
                                                options={chartOptions}
                                            />
                                        </>}

                                        {authData?.UserType === "districtuser" || authData?.UserType === "User" ? "" :
                                            <button
                                                className="btn-refresh2"
                                                onClick={handleRefresh}
                                                style={{ marginTop: "14px" }}
                                            >
                                                {isTheme === 'light' ?
                                                    <img src="img/refreshlight.svg" alt="refresh" width="20px" height="20px" />
                                                    :
                                                    <img src="img/refresh.svg" alt="refresh" />
                                                }
                                                Refresh
                                            </button>
                                        }


                                    </div>
                                </div>
                            </div>
                        )}
                    </div>
                </div>
            )}
            <div className='px-2'>
                <div className='row'>
                    {!isTableView && (
                        <div className='col-md-4 p-0'>
                            <div className="row">
                                {stats.map((s, idx) => {
                                    // Check if this is the last card AND total cards % 6 != 0
                                    const isLastCard = idx === stats.length - 1;
                                    const shouldFullWidth = isLastCard && stats.length % 6 !== 0;
                                    return (
                                        <div
                                            key={idx}
                                            className={`${shouldFullWidth ? "col-12" : "col-md-6"} mt-2`} // 6 cards per row = col-md-2
                                            style={{ rowGap: "10px" }}
                                            onClick={() => handleGetData(s)}
                                        >
                                            <div className={`property-tax-in-${idx} text-center px-2 py-2`}>
                                                <h3 className={`m-0 property-card-id-titlein tax-property-h3-${idx}`}>
                                                    {formatNumberWithCommas(s.value)}
                                                </h3>
                                                <p className={`property-card-id-text-in m-0 tax-property-h3-${idx}`}>
                                                    {s.title}
                                                </p>
                                            </div>
                                        </div>
                                    );
                                })}
                            </div>
                        </div>
                    )}
                    <div className={isTableView ? 'col-md-12 mt-3 px-2' : 'col-md-8 px-2'}>
                        <div className="d-flex justify-content-between align-items-center">
                            <div className="tabs-container">
                                <button
                                    className={`tab-btn ${active === "total" ? "active" : ""}`}
                                    onClick={() => {
                                        filterProperties("total");
                                        setActive("total");
                                        setRefactive("0");
                                    }}
                                >
                                    Total Property
                                </button>
                                <button
                                    className={`tab-btn ${active === "Paid" ? "active" : ""}`}
                                    onClick={() => {
                                        filterProperties("Paid");
                                        setActive("Paid");
                                        setRefactive("0");
                                    }}
                                >
                                    Paid
                                </button>
                                <button
                                    className={`tab-btn ${active === "Unpaid" ? "active" : ""}`}
                                    onClick={() => {
                                        filterProperties("Unpaid");
                                        setActive("Unpaid");
                                        setRefactive("0");
                                    }}
                                >
                                    Unpaid
                                </button>
                                <button
                                    className={`tab-btn ${active === "Not Registered" ? "active" : ""}`}
                                    onClick={() => {
                                        filterProperties("Not Registered");
                                        setActive("Not Registered");
                                        setRefactive("0");
                                    }}
                                >
                                    Not Registered
                                </button>

                                <button
                                    className={`tab-btn ${active === "New" ? "active" : ""}`}
                                    onClick={() => {
                                        filterPropertiesYet("New");
                                        setActive("New");
                                    }}
                                >
                                    Yet to be Surveyed
                                </button>

                                <button
                                    className={`tab-btn ${active === "Negative Arrear" ? "active" : ""}`}
                                    onClick={() => {
                                        filterProperties("Negative Arrear");
                                        setActive("Negative Arrear");
                                        setRefactive("0");
                                    }}
                                >
                                    Negative Arrear
                                </button>
                            </div>
                            <div className='d-flex gap-3'>
                                {ulbCode && (
                                    <button className='gradient-btn' onClick={downloadExcel}><img src="img/gradiant-download.svg" alt='download' /> Download Data</button>
                                )}
                                <button onClick={handleTableView} className='btn p-0 btn-titles btn-titlesdiv'><img src="img/expand-icon.svg" alt='Maximise Panel' />{isTableView ? 'Minimise' : "Maximise "} Table</button>
                            </div>
                        </div>

                        {/* Table with Loader */}
                        <div className='property-change-table-wrapper mt-2 relative table-indentify'>
                            <DataTable
                                value={filteredPropertyData}
                                scrollable
                                // scrollHeight={isTableView ? 'calc(100vh - 215px)' : '135px'}
                                scrollHeight={
                                    isTableView
                                        ? (isToolHeight ? "calc(100vh - 215px)" : "calc(100vh - 310px)")
                                        : (isToolHeight ? "135px" : "135px")
                                }
                                loading={isTableLoading}
                                emptyMessage="No data found"
                                resizableColumns
                                columnResizeMode="expand"
                                style={{ minWidth: '10rem', width: '100%' }}
                            >
                                {!isTableLoading && (
                                    <Column field="index" header="S.No" body={(data, options) => first + options.rowIndex + 1} style={{ textAlign: 'center' }} />
                                )}
                                {columns.map((col) => (
                                    <Column
                                        key={col.field}
                                        field={col.field}
                                        header={col.header}
                                        sortable
                                        // style={{ whiteSpace: 'nowrap', minWidth: '150px' }}
                                        style={{ minWidth: '150px', maxWidth: '250px' }}  // limit column width
                                        headerStyle={{ textAlign: 'center', justifyContent: 'center' }}
                                        bodyStyle={{ textAlign: 'center', justifyContent: 'center' }}
                                        body={(rowData) => (<span title={rowData[col.field]}
                                            className="truncate-text"
                                        >{rowData[col.field]}</span>)}
                                    />
                                ))}
                            </DataTable>

                            {totalRecords > 0 && (
                                <div className="fixed-pagination custome-pagination">
                                    <Paginator
                                        first={first}
                                        rows={rows}
                                        totalRecords={totalRecords}
                                        rowsPerPageOptions={[100, 200, 500, 2000]}
                                        onPageChange={onPageChangePrimeReact}
                                        template={{
                                            layout: 'FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown',
                                            RowsPerPageDropdown: () => {
                                                const dropdownOptions = [
                                                    { label: 100, value: 100 }, { label: 200, value: 200 },
                                                    { label: 500, value: 500 }, { label: 2000, value: 2000 }
                                                ];
                                                return (
                                                    <select value={rows} onChange={(e) => onRowsChangePrimeReact(Number(e.target.value))}
                                                        style={{ padding: '0', borderRadius: '3px', border: '1px solid #ced4da', marginLeft: '1rem' }}>
                                                        {dropdownOptions.map(option => (<option key={option.value} value={option.value}>{option.label}</option>))}
                                                    </select>
                                                );
                                            }
                                        }}
                                        currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
                                        style={{ position: 'sticky', bottom: 0, backgroundColor: '#e6fffa', padding: '0.5rem', borderTop: '1px solid #dee2e6', zIndex: 10 }}
                                    />
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </div >

            {/* Global Loading Overlay */}
            {/* {isLoading && (
        <div className="loading-overlay">
          <div className="spinner-border text-primary" role="status">
            <span className="visually-hidden">Loading...</span>
          </div>
        </div>
      )} */}
        </div >
    )
}

export default PropertyChangeMap2;
